
<div class="container mb-3 p-0">
  <div #confirmationCard class="col-10 col-md-6 col-lg-4 m-auto text-center mt-3 w-100 cardPreRegistration" style="border-radius:20px">
    <header class="text-center print-visible">
      <h2 class="print-visible confirmacao mb-4 text-uppercase">
        Presença confirmada
        <br>
      </h2>

      <p class="print-visible mb-0 text-center" style="color: #f59a3e;margin-top: 30px;">Encontro Presencial</p>
      <p class="print-visible mb-0 text-center" style="font-style: italic;">{{preRegistration().meeting.name}}</p>
      <p class="print-visible mb-0 text-center" style="font-style: italic;">{{preRegistration().meeting.beginDate}}</p>
      <p class="print-visible mb-0 text-center">{{preRegistration().meeting.place}}</p>
      <p class="print-visible mb-0 text-center">{{preRegistration().meeting.address}}</p>
      <p class="print-visible mb-4 text-center">{{preRegistration().meeting.localityPlace.name}}</p>

      <h4 class="person-name m-0">{{preRegistration().person.name}}</h4>
      <h6 class="mb-4">
        {{preRegistration().role}}
        <br>
        {{preRegistration().organization}}
      </h6>
    </header>
    <div class="mt-0">
      <em class="informacoes print-visible">O representante deve apresentar o QR Code na entrada do evento para registrar sua chegada</em><br />
      <img src="data:image/png;base64,{{preRegistration().qrcode}}"  alt="QR Code - Audiências Públicas" class="qr-code img-fluid print-visible">
    </div>
    <div class="mb-3">
      <em class="informacoes-adicionais mb-3 print-visible p-2">Já o encaminhamos para o seu e-mail {{sendedTo}}, mas você pode também:</em><br/>
    </div>
    <a type="button" (click)="saveImage()" class="btn btn-sm btn-outline-primary ms-2 action-buttons mb-2">
      <span class="iconText">Salvar</span>
      <i class="fas fa-download"></i>
    </a>
    <a type="button" (click)="print()" class="btn btn-sm btn-outline-primary ms-2 action-buttons mb-2">
      <span class="iconText">Imprimir</span>
      <i class="fas fa-print"></i>
    </a>
    <div class="mb-3">
      <button class="btn btn-primary text-center" (click)="forceReload()">Corrigir ou Confirmar novos representantes</button>
    </div>
    <p class="print-visible mb-0 mt-4 text-center">
      <img class="img-fluid print-visible img-logo-es" src="assets/images/brasao.png" >
    </p>
  </div>
</div>
<canvas #canvas style="display: none;"></canvas>
